import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OrderPayTransparencyData } from "../../../../typings";

@Injectable({
  providedIn: 'root'
})
export class PayTransparencyService {
  private payTransparencyDataSubject = new BehaviorSubject<OrderPayTransparencyData>(null);
  payTransparencyData$ = this.payTransparencyDataSubject.asObservable();

  setPayTransparencyData(data: OrderPayTransparencyData) {
    this.payTransparencyDataSubject.next(data);
  }

  getPayTransparencyData() {
    return this.payTransparencyDataSubject.getValue();
  }
}
